import { Component, Input, Renderer2, forwardRef, QueryList, ContentChildren, ViewChild, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { IonicPage, SegmentButton } from 'ionic-angular';

/**
 * Generated class for the GdxRatingPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'gdx-segment',
  templateUrl: 'gdx-segment.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GdxSegmentPage),
      multi: true
    }
  ]
})
export class GdxSegmentPage {
  @Input() value: any;
  @Input() mode: any;
  @Output() gdxChange = new EventEmitter<any>();
  
  @ViewChild('segment') segment: ElementRef;
  @ContentChildren(SegmentButton) _buttons: QueryList<SegmentButton>;

  disableLeft: boolean = true;
  disableRight: boolean = false;
  screenWidth: any;

  onChange: any = () => {
  };
  onTouched: any = () => {
  };
  
  constructor(
    private renderer: Renderer2
  ) {

  }

  ngOnInit() {
    this.screenWidth = window.innerWidth;
  }

  // #region: Create Method for formcontrol and ngModel
  registerOnChange(fn) {
    this.onChange = fn;
    console.log(fn, 'registerOnChange registerOnChange')
  }

  writeValue(value) {
    if (value) {
      this.value = value;
      this.onChange(this.value);
      this.selectedStyle();
      console.log('this.onChange writeValue', this.onChange, this.value);
    }
  }

  registerOnTouched(fn) {
    console.log(fn,'registerOnTouched');
    this.onTouched = fn;
  }

  segmentChanged(ev){
    console.log(ev)
    this.value = ev.value
  }

  ngAfterViewInit(): void {
    console.log('ell querySelectorAll 1',this.segment.nativeElement.querySelectorAll("ion-segment-button"));
  }

  ngAfterContentInit() {
    this._buttons.forEach(button => {
      button.ionSelect.subscribe((selectedButton: any) => {
        this.value = selectedButton.value;
        this.selectedStyle();
      });
    });
  }

  selectedStyle(){
    this.segment.nativeElement.querySelectorAll("ion-segment-button").forEach(el => {
      this.renderer.removeClass(el, 'gdx-segment-activated');
      let item = Array.prototype.slice.call(el.attributes).filter(element => element.name === 'value');
      if(item[0].value === this.value){
        this.onChange(this.value);
        this.gdxChange.emit(this.value);
        this.renderer.addClass(el, 'gdx-segment-activated');
      }else{
        this.renderer.removeClass(el, 'gdx-segment-activated');
      }
    });
  }

  check(){
    console.log('_buttons', this._buttons);
    console.log('segment', this.segment);
    console.log('segment querySelectorAll',this.segment.nativeElement.querySelectorAll("ion-segment-button"));
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenWidth = window.innerWidth;
    console.log('this.screenWidth', this.screenWidth);
  }

  onScroll(e) {
    if (this.screenWidth >= 768) {
      if (this.segment.nativeElement.scrollLeft <= 0) {
        this.disableLeft = true;
      } else {
        this.disableLeft = false;
      }
      if (this.segment.nativeElement.clientWidth + this.segment.nativeElement.scrollLeft >= this.segment.nativeElement.scrollWidth) {
        this.disableRight = true;
      } else {
        this.disableRight = false;
      }
    }
  }

  slideLeft() {
    this.disableRight = false;
    if (this.screenWidth >= 768) {
      this.segment.nativeElement.scrollLeft -= this.segment.nativeElement.clientWidth;
      if (this.segment.nativeElement.scrollLeft <= 0) {
        this.disableLeft = true;
      }
    }

  }

  slideRight() {
    this.disableLeft = false;
    if (this.screenWidth >= 768) {
      this.segment.nativeElement.scrollLeft += this.segment.nativeElement.clientWidth;
      if (this.segment.nativeElement.clientWidth + this.segment.nativeElement.scrollLeft >= this.segment.nativeElement.scrollWidth) {
        this.disableRight = true;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/gdx-segment/gdx-segment.ts